<particle-analytics-content [isNavContentPaneEnabled]="true"
                            [reportType]="'AuditTracker'"
                            [solutionName]="'AuditTracker'"
                            [isResetButtonEnabled]="true"
                            [isEditButtonEnabled]="true"
                            [pageName]="'Cases'"
>

</particle-analytics-content>
